import cx from 'classnames';
import { capfirst, intcomma } from 'journalize';
import { Component, h, VNode } from 'preact';

import PartyPill from './PartyPill';
import PureComponent from './PureComponent';

interface Props {
  ballotName: string;
  candidateId: string;
  contestIsCalled: boolean;
  isIncumbent: boolean;
  isWinner: boolean;
  party: string;
  totalVotesInContest: number;
  votes: number;
}

class CandidateRow extends Component<Props> {
  render() {
    const { ballotName, party, isIncumbent } = this.props;

    return (
      <tr class="candidate race__candidate-row">
        <td class="candidate__cell candidate__party">
          <PartyPill party={party} />
        </td>

        <th scope="row" class="candidate__cell candidate__name">
          {ballotName}{' '}
          {isIncumbent == 'Yes' && (
            <span class="pill pill--basic" title="Currently holds this seat">
              Incumbent
            </span>
          )}
        </th>
      </tr>
    );
  }
}

CandidateRow.defaultProps = {
  contestIsCalled: false,
};

export default CandidateRow;
